"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MinicartContextProvider = exports.useMinicart = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MinicartContext = /*#__PURE__*/_react["default"].createContext();
var minicartDefault = {
  isMinicartVisible: false,
  minicartContent: [],
  isSetFromLocalStorage: false,
  temporaryMinicartQty: null,
  temporaryChangedProduct: null,
  temporaryQtyChange: null,
  isCouponCodeFormPromotions: false
};
var MinicartContextProvider = function MinicartContextProvider(props) {
  var isFirstRun = (0, _react.useRef)(true);
  var _useState = (0, _react.useState)(false),
    isMinicartLoading = _useState[0],
    setMinicartLoading = _useState[1];
  var _useState2 = (0, _react.useState)(minicartDefault),
    minicartState = _useState2[0],
    changeMinicartState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      var _localStorage;
      isFirstRun.current = false;
      var initialCart = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("minicartContent");
      var parsedInitialCart = initialCart ? JSON.parse(initialCart).items : [];
      changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
        minicartContent: parsedInitialCart,
        isSetFromLocalStorage: true
      }));
    }
  }, []);
  var countItemsAmount = function countItemsAmount(currentMinicartContent) {
    if (!currentMinicartContent || (currentMinicartContent === null || currentMinicartContent === void 0 ? void 0 : currentMinicartContent.length) === 0) return 0;
    var itemsAmount = 0;
    currentMinicartContent.forEach(function (item) {
      itemsAmount += item.quantity;
    });
    return itemsAmount;
  };
  var updateTemporaryData = function updateTemporaryData() {
    var quantityDifference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var changedProduct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    quantityDifference === null ? changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      temporaryMinicartQty: quantityDifference,
      temporaryChangedProduct: changedProduct,
      temporaryQtyChange: quantityDifference
    })) : changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      temporaryMinicartQty: countItemsAmount(minicartState.minicartContent) + quantityDifference,
      temporaryChangedProduct: changedProduct,
      temporaryQtyChange: quantityDifference
    }));
  };
  var getCurrentPrice = function getCurrentPrice(price, quantity, isCheckout, discountTemp) {
    if (!price) return 0;
    if (price !== null && price !== void 0 && price.discountFromTotals) {
      return ((price === null || price === void 0 ? void 0 : price.special) || (price === null || price === void 0 ? void 0 : price.regular)) * quantity - (isCheckout ? 0 : price === null || price === void 0 ? void 0 : price.discountFromTotals);
    }
    return ((price === null || price === void 0 ? void 0 : price.special) || (price === null || price === void 0 ? void 0 : price.regular) || 0) * quantity;
  };
  var getMinicartTotalPrice = function getMinicartTotalPrice(currentMinicartContent) {
    var isCheckout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!currentMinicartContent || (currentMinicartContent === null || currentMinicartContent === void 0 ? void 0 : currentMinicartContent.length) === 0) return 0;
    var price = 0;
    var temporaryPriceAddition = 0;
    currentMinicartContent.map(function (item, index) {
      var _item$product;
      var itemPrice = getCurrentPrice(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.price, item.quantity, isCheckout);
      price += itemPrice;
      if (minicartState.temporaryMinicartQty !== null) {
        var _ref;
        var qtyBefore = minicartState.temporaryQtyChange * -1 + minicartState.temporaryMinicartQty;
        var discountDiffrence = 0;
        if (qtyBefore === item.quantity) {
          var _item$product2, _item$product2$price, _item$product3, _item$product3$price;
          discountDiffrence = (item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$price = _item$product2.price) === null || _item$product2$price === void 0 ? void 0 : _item$product2$price.discountFromTotals) / qtyBefore * minicartState.temporaryMinicartQty * -1 + ((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : (_item$product3$price = _item$product3.price) === null || _item$product3$price === void 0 ? void 0 : _item$product3$price.discountFromTotals);
        }
        var _minicartState$tempor = minicartState.temporaryChangedProduct.price,
          special = _minicartState$tempor.special,
          regular = _minicartState$tempor.regular;
        temporaryPriceAddition = (_ref = (special || regular) * minicartState.temporaryQtyChange + discountDiffrence) !== null && _ref !== void 0 ? _ref : 0;
      }
    });
    return minicartState.temporaryMinicartQty === null ? price : price + temporaryPriceAddition;
  };
  var toggleMinicartVisibility = function toggleMinicartVisibility() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        close: false
      },
      close = _ref2.close;
    if (close && !minicartState.isMinicartVisible) {
      return;
    }
    if (close) {
      changeMinicartState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isMinicartVisible: false
        });
      });
      return;
    }
    if (isMinicartLoading) return;
    changeMinicartState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isMinicartVisible: !prev.isMinicartVisible
      });
    });
  };
  var updateMinicartContent = function updateMinicartContent(sku, quantity) {
    var minicartWithUpdatedProductQuantity = [];
    minicartState.minicartContent.map(function (item) {
      if (parseInt(item.product.sku) === parseInt(sku)) {
        item.quantity = quantity;
      }
      minicartWithUpdatedProductQuantity.push(item);
    });
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithUpdatedProductQuantity
    }));
  };
  var addNewItemToMinicart = function addNewItemToMinicart(product, quantity) {
    var _minicartState$minica;
    var itemInCart = (_minicartState$minica = minicartState.minicartContent) === null || _minicartState$minica === void 0 ? void 0 : _minicartState$minica.find(function (item) {
      var _item$product4;
      return parseInt((_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.sku) === parseInt(product.sku);
    });
    if (itemInCart) {
      updateMinicartContent(product.sku, itemInCart.quantity + quantity);
      return;
    }
    var minicartWithNewItemAdded = [].concat((0, _toConsumableArray2["default"])(minicartState.minicartContent), [{
      name: product.name,
      sku: product.sku,
      product: product,
      quantity: quantity
    }]);
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithNewItemAdded
    }));
  };
  var removeItemFromMinicart = function removeItemFromMinicart(sku) {
    var minicartWithItemRemoved = minicartState.minicartContent.filter(function (item) {
      return parseInt(item.sku) !== parseInt(sku);
    });
    changeMinicartState(_objectSpread(_objectSpread({}, minicartState), {}, {
      minicartContent: minicartWithItemRemoved
    }));
  };
  var setMinicartContentFromStorage = function setMinicartContentFromStorage() {
    var cart = localStorage.getItem("minicartContent");
    var parsedCart = cart ? JSON.parse(cart) : [];
    changeMinicartState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        minicartContent: parsedCart !== null && parsedCart !== void 0 && parsedCart.items ? parsedCart.items : [],
        isSetFromLocalStorage: true
      });
    });
  };
  var setCouponCodeFormPromotions = function setCouponCodeFormPromotions(isCouponCodeFormPromotions) {
    changeMinicartState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isCouponCodeFormPromotions: isCouponCodeFormPromotions
      });
    });
  };
  var clearMinicartState = function clearMinicartState() {
    changeMinicartState(minicartDefault);
  };
  return __jsx(MinicartContext.Provider, {
    value: {
      isMinicartLoading: isMinicartLoading,
      setMinicartLoading: setMinicartLoading,
      isMinicartVisible: minicartState.isMinicartVisible,
      minicartContent: minicartState.minicartContent,
      itemsAmount: minicartState.temporaryMinicartQty === null ? countItemsAmount(minicartState.minicartContent) : minicartState.temporaryMinicartQty,
      minicartTotalPrice: function minicartTotalPrice(isCheckout) {
        return getMinicartTotalPrice(minicartState.minicartContent, isCheckout);
      },
      setCouponCodeFormPromotions: setCouponCodeFormPromotions,
      showDiscountInProductRow: minicartState.isCouponCodeFormPromotions,
      toggleMinicartVisibility: toggleMinicartVisibility,
      addNewItemToMinicart: addNewItemToMinicart,
      removeItemFromMinicart: removeItemFromMinicart,
      updateMinicartContent: updateMinicartContent,
      setMinicartContentFromStorage: setMinicartContentFromStorage,
      changeMinicartState: changeMinicartState,
      minicartState: minicartState,
      clearMinicartState: clearMinicartState,
      updateTemporaryData: updateTemporaryData
    }
  }, props.children);
};
exports.MinicartContextProvider = MinicartContextProvider;
var useMinicart = function useMinicart() {
  return (0, _react.useContext)(MinicartContext);
};
exports.useMinicart = useMinicart;